export enum DocumentStatus {
  NOT_STARTED = "Not started",
  IN_PROGRESS = "In progress",
  COMPLETED = "Completed",
  ERROR = "Error",
  FAILED = "Failed"
}

export enum ActivityStatus {
  NOT_STARTED = "Not started",
  IN_PROGRESS = "In progress",
  COMPLETED = "Completed",
  ERROR = "Error"
}

export enum DocumentType {
  ENGINEERING = "Engineering",
  CONTRACT = "Contract",
  INVOICE = "Invoice",
  OTHERS = "Others",
  DOC = "Doc"
}

export enum ProcessingAction {
  VIEW = "view",
  DELETE = "delete",
  PROCESS = "process",
  REFRESH = "refresh"
}

export enum UploadStatus {
  PENDING = "pending",
  UPLOADING = "uploading",
  SUCCESS = "success",
  ERROR = "error"
}

export enum AssignmentStatus {
  PRIVATE = "Private",
  PUBLIC = "Public",
  DRAFT = "Draft"
}
